module.exports = {
          srcSet: __webpack_public_path__ + "public/images/ed5debb2c1844f98dad691a2cde07ba8-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/ed5debb2c1844f98dad691a2cde07ba8-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/ed5debb2c1844f98dad691a2cde07ba8-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/ed5debb2c1844f98dad691a2cde07ba8-1774.webp"},
          
          width: 1774,
          height: 887
        }